import React from 'react';
import {
  Box,
  BottomNavigation,
  BottomNavigationAction,
  Badge,
  Paper
} from '@mui/material';
import {
  Dashboard as DashboardIcon,
  Inbox as InboxIcon,
  Notifications as MentionsIcon,
  AssignmentLate as UnassignedIcon,
  FactCheck as ClosedIcon,
  Chat as ChatIcon,
  Info as InfoIcon,
  ConfirmationNumber as TicketIcon
} from '@mui/icons-material';

const MobileNavigation = ({
  activeSection,
  onSectionChange,
  activeView,
  onViewChange,
  unreadCount,
  theme,
  selectedTab,
  onTabChange
}) => {
  const getActiveValue = () => {
    if (activeView === 'navigation') {
      return activeSection;
    } else if (activeView === 'tickets') {
      return 'tickets';
    } else if (activeView === 'chat') {
      return `tab-${selectedTab}`; // Differentiate tabs with a prefix
    } else if (activeView === 'details') {
      return 'details';
    }
    return activeSection;
  };

  const handleChange = (event, newValue) => {
    // Handle tab changes when in chat view
    if (activeView === 'chat' && newValue.startsWith('tab-')) {
      onTabChange(event, parseInt(newValue.replace('tab-', '')));
      return;
    }
    
    // Handle navigation between views
    if (newValue === 'tickets') {
      onViewChange('tickets');
    } else if (newValue.startsWith('tab-')) {
      onTabChange(event, parseInt(newValue.replace('tab-', '')));
      onViewChange('chat');
    } else if (newValue === 'details') {
      onViewChange('details');
    } else {
      onSectionChange(newValue);
      onViewChange('navigation');
    }
  };

  return (
    <Paper
      sx={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 10,
        backgroundColor: 'rgba(26, 32, 44, 0.95)',
        backdropFilter: 'blur(10px)',
        borderTop: '1px solid rgba(255, 255, 255, 0.1)'
      }}
      elevation={3}
    >
      <BottomNavigation
        value={getActiveValue()}
        onChange={handleChange}
        sx={{
          backgroundColor: 'transparent',
          height: 60,
          '& .MuiBottomNavigationAction-root': {
            color: 'rgba(255, 255, 255, 0.5)',
            '&.Mui-selected': {
              color: theme.palette.primary.main
            }
          }
        }}
      >
        {activeView === 'chat' ? (
          // Show tabs when in chat view
          <>
            <BottomNavigationAction
              label="Dashboard"
              value="tab-0"
              icon={<DashboardIcon />}
            />
            <BottomNavigationAction
              label="Tickets"
              value="tab-1"
              icon={<TicketIcon />}
            />
            <BottomNavigationAction
              label="Live Chat"
              value="tab-2"
              icon={<ChatIcon />}
            />
            <BottomNavigationAction
              label="History"
              value="tab-3"
              icon={<HistoryIcon />}
            />
          </>
        ) : (
          // Show navigation when in other views
          <>
            <BottomNavigationAction
              label="Dashboard"
              value="dashboard"
              icon={<DashboardIcon />}
            />
            <BottomNavigationAction
              label="Inbox"
              value="inbox"
              icon={
                <Badge
                  color="error"
                  badgeContent={unreadCount.inbox}
                  max={99}
                  sx={{
                    '& .MuiBadge-badge': {
                      fontSize: '0.6rem',
                      height: '16px',
                      minWidth: '16px'
                    }
                  }}
                >
                  <InboxIcon />
                </Badge>
              }
            />
            {activeView === 'tickets' && (
              <BottomNavigationAction
                label="Chat"
                value="tab-0"
                icon={<ChatIcon />}
              />
            )}
            {activeView !== 'tickets' && (
              <BottomNavigationAction
                label="Mentions"
                value="mentions"
                icon={
                  <Badge
                    color="error"
                    badgeContent={unreadCount.mentions}
                    max={99}
                    sx={{
                      '& .MuiBadge-badge': {
                        fontSize: '0.6rem',
                        height: '16px',
                        minWidth: '16px'
                      }
                    }}
                  >
                    <MentionsIcon />
                  </Badge>
                }
              />
            )}
            <BottomNavigationAction
              label="Unassigned"
              value="unassigned"
              icon={
                <Badge
                  color="error"
                  badgeContent={unreadCount.unassigned}
                  max={99}
                  sx={{
                    '& .MuiBadge-badge': {
                      fontSize: '0.6rem',
                      height: '16px',
                      minWidth: '16px'
                    }
                  }}
                >
                  <UnassignedIcon />
                </Badge>
              }
            />
          </>
        )}
      </BottomNavigation>
    </Paper>
  );
};

export default MobileNavigation;
